const casaClaim = 'Case e appartamenti in vendita – Annunci immobiliari - Casa.it';
export default casaClaim;
